import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { BaseModalComponent } from '../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'simple-table-modal',
  templateUrl: 'simple-table-modal.component.html',
  styleUrls: ['simple-table-modal.component.scss'],
})
export class SimpleTableModalComponent extends BaseModalComponent {

  @Input() title: string;

  @Input() note: string;

  @Input() data: string;

  @Input() showNote: boolean = true;

}
